export default {
    // --------Title--------
    modifyContainer: 'Modify Container',
    container: 'Container',
    registeredContainerInformation: 'Registered container information',
    detailInformationAboutTheItemsInvolved: 'Detail information about the items involved',
    uploadExcel: 'Upload Excel',
    selectThePackingDocumentToImport: 'Select the packing document to import',
    provideInformationAboutContainer: 'Provide information about container',
    availableProducts: 'Available Products',
    availableItems: 'Available Items',
    containerInformation: 'Container Information',
    detailsInformationAboutContainer: 'Details information about container',
    searchSupplierNoOrSignedByOrMarking: `Search Supplier/Company/PNo. / Signed By / Marking`,
    modifyLoadContainerDateTime: `Modify Load Container DateTime`,

    // --------Dialog & Drawer Title-------
    addContainerItems: 'Add Container Items',
    customerMarking: 'Customer Marking',
    searchCustomerDetailsByMarking: 'Search customer details by marking',
    searchCustomerByMarking: 'Search Customer By Marking',
    updateContainerInformation: 'Update Container Information',
    relatedWarehouseLocationToProcess: 'Related warehouse location to process',
    fileName: 'Filename :',
    calculateTheSummaryOfTheContainerInformationPerformValidationBeforeImportIntoSystem: 'Let system to calculate the summary of the container information, perform validation before import into system',
    updateRemark: 'Update Remark',
    proofOfDelivery: 'Proof Of Delivery',
    proofOfDeliveryDetails: 'Proof of Delivery Details',

    mixedLCL: "散柜 LCL",
    fullFCL: "全柜 FCL",
    shipLCL: "船公司 LCL",

    // ----------MUI--------
    modify: 'Modify',
    importPackingExcel: 'Import Packing Excel',
    downloadPackingExcelFull: 'Download Packing Excel (Full)',
    downloadPackingExcelSimple: 'Download Packing Excel (Simple)',
    repositoryNo: 'Repository No.',
    repositoryAltNo: 'Repository Alt No.',
    containerNo: 'Container No.',
    secondaryNo: 'Secondary No.',
    sealNo: 'Seal No.',
    loadDate: 'Load Date',
    customAgent: 'Custom Agent',

    locationName: 'Location Name',
    destinationLocation: 'Destination Location',
    action: 'Action',
    containerSize: 'Container Size',
    containerType: 'Container Type',
    repositoryMarking: 'Repository Marking',
    initialDate: 'Initial Date',
    supervisor: 'Supervisor',
    shipper: 'Shipper',
    totalPackQty: 'Total Pack Qty',
    totalValues: 'Total Values',
    totalWeight: 'Total Weight',
    totalCbm: 'Total CBM',

    splitProductItems: 'Split Product Items',
    status: 'Status',
    courierNo: 'Courier No.',
    purchaseNo: 'Purchase No.',
    packQty: 'Pack Qty',
    values: 'Values',
    weight: 'Weight',
    qty: 'Qty',
    signedBy: 'Signed By',
    loadDateTime: 'Load Datetime',
    createdatetime: 'Created At',
    no: 'No.',
    dimension: 'Dimension (LxHxW)',
    used: 'Used',
    loadQty: 'Load Qty',
    createDateTime: 'Created At',
    uploadFile: 'Upload File',
    downloadTemplate: 'Download Template',
    confirmImport: 'Confirm Import',
    close: 'Close',
    noProofDetailAtTheMoment: 'No delivery proof details at the moment!',

}